export const types = {
    SET_GET_PLAYERS: '[PLAYERS] SET GET PLAYERS',
    SET_GET_PLAYERS_BY_ID: '[ROLE] SET GET PLAYERS BY ID'
}